import React, { useState } from "react"
import { Card, CardBody, Collapse } from "reactstrap"
import classnames from "classnames"
import UserListreportaccordian from "./UserListreportaccordian"

const Projectaccordian = props => {
  const { reports } = props

  const [handleAccordion, sethandleAccordion] = useState(false)

  const handleOnclickAccordion = value => {
    if (handleAccordion === value) {
      sethandleAccordion(null)
    } else {
      sethandleAccordion(value)
    }
  }

  return (
    <>
      <Card>
        <CardBody>
          {reports?.map((proj, keyId) => (
            <div className="accordion" id="accordion" key={keyId}>
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingOne">
                  <button
                    className={classnames("accordion-button", "fw-medium", {
                      collapsed: handleAccordion !== keyId,
                    })}
                    type="button"
                    onClick={() => handleOnclickAccordion(keyId)}
                    style={{ cursor: "pointer" }}
                  >
                    {proj?.projectName}
                    <span style={{ position: "absolute", right: "10%" }}>
                      {proj?.totalHoursWorked}
                    </span>
                  </button>
                </h2>

                <Collapse
                  isOpen={handleAccordion === keyId}
                  className="accordion-collapse"
                >
                  <div className="accordion-body">
                    <div className="text-muted">
                      <strong className="text-dark">
                        <UserListreportaccordian userlist={proj?.usersList} />
                      </strong>
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
          ))}
        </CardBody>
      </Card>

      {reports === null && (
        <Card>
          <CardBody>
            <div>
              <div className="text-center">No Records Found</div>
            </div>
          </CardBody>
        </Card>
      )}
      {reports?.length === 0 && (
        <Card>
          <CardBody>
            <div>
              <div className="text-center">No Records Found</div>
            </div>
          </CardBody>
        </Card>
      )}
    </>
  )
}

export default Projectaccordian
